<sto-app-header
  [breadCrumbs]="breadcrumbs"
  [environmentName]="env?.RADIX_ENVIRONMENT"
  [homeBreadCrumbConfig]="homeBreadCrumbConfig"
  [testEnvironment]="(env?.RADIX_ENVIRONMENT | uppercase) !== 'PRODUCTION'"
  [userMenu]="menu"
>
  @if (!hideReleaseNotes()) {
    <ct-release-notes></ct-release-notes>
  }
  @if (feedbackMailto) {
    <button
      matIconButton
      (click)="openFeedback()"
      matTooltip="Feedback"
      aria-label="Feedback"
      data-testid="feedback-button"
    >
      <mat-icon>feedback</mat-icon>
    </button>
  }
</sto-app-header>
<mat-menu #menu="matMenu">
  <button class="dense" mat-menu-item>{{ user ? user.name : 'Not logged in' }}</button>
  <button (click)="logout.emit()" class="dense" mat-menu-item>Sign out</button>
</mat-menu>

<sto-nav-drawer
  (activate)="collapsed = true"
  [collapsed]="collapsed"
  [navigationItems]="navigation()"
  [withAppHeader]="true"
></sto-nav-drawer>
